/* Ayurvedic Wholesale – GA4 e-commerce data layer for Google Tag Manager (GTM-5LPJWPSP).
   Pushes Google's standard GA4 e-commerce events to window.dataLayer:
     view_item_list  products actually seen on screen (50% visible), batched per list
     select_item     product clicked in a list
     view_item       product page viewed
     add_to_cart     any add to cart on the site (product page, sticky bar, quick add, packs, upsell, FBT, recently viewed)
     remove_from_cart / quantity decreases in cart page or drawer
     view_cart       cart page or cart drawer opened
   plus interaction events: menu_click, link_click (with link_location), whatsapp_click / phone_click / email_click,
   form_begin / form_submit_success / form_error, search, search_no_suggestions, concern_finder_open / _close / _language, concern_search,
   article_progress, faq_open, filter_apply, sort_change, select_pack, buy_now_click, review_form_open, gallery_interaction,
   share, checkout_click, coupon_apply, free_shipping_reached, out_of_stock_view.
   Page context for every hit (page_type, landing_page, previous_page, link_location) is read by GTM's Google tag
   from sessionStorage (aw_nav, written here on every link click) and document.referrer.
   Checkout steps and purchase come from the Shopify custom pixel (Settings > Customer events),
   because Shopify checkout does not run theme code.
   Every product keeps the list it was found in (item_list_id / item_list_name), so the same product
   shown on the homepage, a collection and a related strip is reported separately.
   Performance: only a tiny fetch hook runs at load; everything else waits for browser idle time. */
(function () {
  'use strict';
  var W = window, D = document;
  if (W.awGA) return;
  W.awGA = true;
  W.dataLayer = W.dataLayer || [];
  var CUR = (W.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
  var DAY = 864e5;

  /* ---------- helpers ---------- */
  var idle = W.requestIdleCallback ? function (f) { requestIdleCallback(f, { timeout: 2500 }); } : function (f) { setTimeout(f, 300); };
  var ls = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var clean = function (s, n) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().slice(0, n || 100); };
  var slug = function (s) { return clean(s, 100).toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, ''); };
  var money = function (cents) { return Math.round(+cents || 0) / 100; };
  var handleOf = function (href) { var m = String(href || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; };

  /* landing page of this visit (first page in the tab session) */
  var landing = '';
  try { landing = sessionStorage.getItem('aw_ga_lp') || ''; if (!landing) { landing = location.pathname; sessionStorage.setItem('aw_ga_lp', landing); } } catch (e) { landing = location.pathname; }
  /* how the visitor reached this page (same logic as the GTM variables "CJS - previous_page" / "CJS - link_location") */
  var navCtx = (function () {
    var o = {}, n = null, r = D.referrer, host = location.hostname.replace(/^www\./, '');
    try { n = JSON.parse(sessionStorage.getItem('aw_nav') || 'null'); } catch (e) {}
    if (n && Date.now() - n.t < 120000 && n.to === location.pathname) { o.prev = n.from; o.loc = n.loc; }
    else if (r) { try { var u = new URL(r); if (u.hostname.replace(/^www\./, '') === host) { o.prev = u.pathname; o.loc = u.pathname === location.pathname ? 'same_page' : '(not set)'; } else { o.prev = '(external) ' + u.hostname; o.loc = 'external'; } } catch (e) {} }
    else { o.prev = '(direct)'; o.loc = 'direct'; }
    return o;
  })();
  var ctxPrev = function () { return navCtx.prev || ''; };

  /* page type, from Shopify's own analytics meta */
  var meta = (W.ShopifyAnalytics && ShopifyAnalytics.meta) || {};
  var pt = (meta.page && meta.page.pageType) || '';
  var path = location.pathname;
  if (!pt) pt = path === '/' ? 'home' : /^\/products\//.test(path) ? 'product' : /^\/collections\/[^/]+/.test(path) ? 'collection' : /^\/collections\/?$/.test(path) ? 'collections' : /^\/search/.test(path) ? 'searchresults' : /^\/cart/.test(path) ? 'cart' : /^\/blogs\/[^/]+\/[^/]+/.test(path) ? 'article' : /^\/blogs\//.test(path) ? 'blog' : /^\/pages\//.test(path) ? 'page' : 'other';
  var h1 = function () { var e = D.querySelector('main h1'); return e ? clean(e.textContent, 60) : ''; };

  function push(evt, ecom, extra) {
    var o = { event: evt, page_type: pt, landing_page: landing };
    if (extra) for (var k in extra) if (extra[k] !== undefined && extra[k] !== '') o[k] = extra[k];
    if (ecom) { W.dataLayer.push({ ecommerce: null }); o.ecommerce = ecom; }
    W.dataLayer.push(o);
  }

  /* ---------- product data cache (handle -> details), filled from cards, product pages, cart and recommendation responses ---------- */
  var cache = ls.get('aw_ga_items', {});
  var cacheDirty = false;
  function remember(h, d) {
    if (!h || !d) return;
    var c = cache[h] || {};
    for (var k in d) if (d[k] !== undefined && d[k] !== null && d[k] !== '') c[k] = d[k];
    c.t = Date.now(); cache[h] = c; cacheDirty = true;
  }
  function saveCache() {
    if (!cacheDirty) return; cacheDirty = false;
    var keys = Object.keys(cache);
    if (keys.length > 300) keys.sort(function (a, b) { return (cache[a].t || 0) - (cache[b].t || 0); }).slice(0, keys.length - 300).forEach(function (k) { delete cache[k]; });
    ls.set('aw_ga_items', cache);
  }
  W.addEventListener('pagehide', saveCache);

  /* list attribution: which list a product was last picked from (30 days), used on view_item / add_to_cart / purchase */
  var attr = ls.get('aw_ga_attr', {});
  function setAttr(h, list) {
    if (!h || !list) return;
    attr[h] = { id: list.id, name: list.name, t: Date.now() };
    var keys = Object.keys(attr);
    keys.forEach(function (k) { if (Date.now() - (attr[k].t || 0) > 30 * DAY) delete attr[k]; });
    keys = Object.keys(attr);
    if (keys.length > 60) keys.sort(function (a, b) { return attr[a].t - attr[b].t; }).slice(0, keys.length - 60).forEach(function (k) { delete attr[k]; });
    ls.set('aw_ga_attr', attr);
  }
  function getAttr(h) { var a = attr[h]; return a && Date.now() - a.t < 30 * DAY ? a : null; }

  function gaItem(h, d, extra) {
    d = d || cache[h] || {};
    var it = { item_id: h || String(d.pid || ''), item_name: d.name || h };
    if (d.brand) it.item_brand = d.brand;
    if (d.cat) it.item_category = d.cat;
    if (d.variant) it.item_variant = d.variant;
    if (d.price !== undefined && d.price !== null && d.price !== '') it.price = +d.price;
    if (extra) for (var k in extra) if (extra[k] !== undefined && extra[k] !== '') it[k] = extra[k];
    return it;
  }

  /* ---------- lists ---------- */
  function pageCtx() {
    switch (pt) {
      case 'home': return 'Home';
      case 'product': return 'Product page';
      case 'collection': return 'Collection: ' + (h1().replace(/^Buy\s+/i, '').replace(/\s+Online$/i, '') || path.split('/')[2]);
      case 'collections': return 'All categories';
      case 'searchresults': return 'Search';
      case 'cart': return 'Cart';
      case 'article': return 'Blog article';
      case 'blog': return 'Blog';
      default: return 'Page: ' + (h1() || path);
    }
  }
  function listOf(el) {
    var name;
    if (el.closest('predictive-search, .predictive-search, .aw-sg')) name = 'Search suggestions';
    else if (el.closest('.aw-hx')) name = pageCtx() + ' – Popular picks';
    else if (el.closest('#aw-rv, .aw-rv')) name = 'Recently viewed';
    else if (el.closest('#aw-fbt, .aw-fbt')) name = 'Frequently bought together';
    else if (el.closest('.aw-up')) name = el.closest('cart-drawer') ? 'Cart drawer upsell' : 'Cart upsell';
    else if (el.closest('cart-drawer')) name = 'Cart drawer';
    else if (el.closest('.aw-fd')) name = 'Concern finder';
    else {
      var sec = el.closest('.shopify-section');
      var id = sec ? sec.id : '';
      if (/__product-grid|__main/.test(id) && (pt === 'collection' || pt === 'searchresults')) name = pt === 'searchresults' ? 'Search results' : pageCtx();
      else {
        var hd = sec && sec.querySelector('h2, .title, .aw-h2');
        var t = hd ? clean(hd.textContent, 60) : (id.split('__').pop() || 'Products');
        name = pageCtx() + ' – ' + t;
      }
    }
    name = clean(name, 100);
    return { id: slug(name), name: name };
  }

  /* product details from a tile */
  function tileData(tile) {
    var holder = tile.hasAttribute('data-aw-item') ? tile : tile.querySelector('[data-aw-item]');
    var raw = holder ? holder.getAttribute('data-aw-item') : '';
    var a = tile.querySelector('a[href*="/products/"]') || (tile.matches('a[href*="/products/"]') ? tile : null);
    var h = a ? handleOf(a.getAttribute('href')) : '';
    var d = null;
    if (raw) { try { d = JSON.parse(raw); h = d.id || h; } catch (e) {} }
    if (!h) return null;
    if (!d) {
      d = Object.assign({}, cache[h] || {});
      if (!d.name) { var t = tile.querySelector('.aw-mp__t, .card__heading, .aw-fbt__t, .aw-fd__t, h3, h4') || a; d.name = clean(t && t.textContent, 100).replace(/^This item:\s*/, ''); }
      if (d.price === undefined) { var p = tile.querySelector('.price-item--sale, .price-item--regular, .aw-mp__p, .aw-fbt__p, .price'); var m = p && p.textContent.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); if (m) d.price = +m[1]; }
    } else remember(h, d);
    return { h: h, d: d };
  }

  var TILE = '.card-wrapper, .aw-hx__card, .aw-mp, .aw-fbt__item, .aw-fd__card, .predictive-search__list-item, .aw-sg__p';

  /* ---------- impressions: view_item_list (only tiles that were really on screen) ---------- */
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var queue = {}, qTimer = null;
  function indexIn(tile, list) {
    var box = tile.closest('ul, .grid, .slider, .aw-mp-grid, .aw-up__list, .aw-fbt__row') || tile.parentElement;
    var all = box ? Array.prototype.filter.call(box.querySelectorAll(TILE), function (x) { return !x.parentElement.closest(TILE); }) : [tile];
    var i = all.indexOf(tile); return i < 0 ? undefined : i + 1;
  }
  function flush() {
    qTimer = null;
    Object.keys(queue).forEach(function (k) {
      var q = queue[k]; delete queue[k];
      for (var i = 0; i < q.items.length; i += 15)
        push('view_item_list', { currency: CUR, item_list_id: q.list.id, item_list_name: q.list.name, items: q.items.slice(i, i + 15) });
    });
  }
  function impress(tile) {
    if (seen) { if (seen.has(tile)) return; seen.add(tile); } else { if (tile._awSeen) return; tile._awSeen = 1; }
    var td = tileData(tile); if (!td) return;
    var list = listOf(tile);
    var q = queue[list.id] || (queue[list.id] = { list: list, items: [] });
    q.items.push(gaItem(td.h, td.d, { item_list_id: list.id, item_list_name: list.name, index: indexIn(tile, list) }));
    if (!qTimer) qTimer = setTimeout(flush, 1000);
  }
  var io = null;
  function observe(root) {
    if (!io) return;
    (root || D).querySelectorAll(TILE).forEach(function (t) {
      if (t.parentElement && t.parentElement.closest(TILE)) return;
      if (t._awObs) return; t._awObs = 1; io.observe(t);
    });
  }
  function startImpressions() {
    if (!('IntersectionObserver' in W)) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { impress(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    observe(D);
    /* tiles added later (recently viewed, upsell, FBT, infinite lists, drawer) */
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { idle(function () { observe(D); }); return; }
    });
    mo.observe(D.body, { childList: true, subtree: true });
    W.addEventListener('pagehide', function () { if (qTimer) { clearTimeout(qTimer); flush(); } });
  }

  /* ---------- where on the page a link sits ---------- */
  var MENU = { mobile_menu: 1, mega_menu: 1, header_menu: 1, header_icons: 1, header_logo: 1, announcement_bar: 1, wholesale_bar: 1, footer: 1, breadcrumb: 1 };
  function linkLoc(a) {
    var c = function (sel) { return a.closest(sel); };
    if (c('.menu-drawer, menu-drawer')) return 'mobile_menu';
    if (c('.mega-menu__content, .header__submenu, .aw-mm__panel, .aw-mm')) return 'mega_menu';
    if (c('.header__inline-menu, .header nav')) return 'header_menu';
    if (c('.header__heading, .header__heading-link')) return 'header_logo';
    if (c('.header__icons')) return 'header_icons';
    if (c('.announcement-bar, .utility-bar')) return 'announcement_bar';
    if (c('.aw-wsbar')) return 'wholesale_bar';
    if (c('predictive-search, .predictive-search, .aw-sg')) return 'search_suggestions';
    if (c('.aw-fd')) return 'concern_finder';
    if (c('.aw-wa')) return 'floating_whatsapp';
    if (c('.aw-satc')) return 'sticky_bar';
    if (c('.aw-cbar')) return 'cart_sticky_bar';
    if (c('cart-drawer')) return 'cart_drawer';
    if (c('.footer, footer, .shopify-section-group-footer-group')) return 'footer';
    if (c('.breadcrumb, .aw-ch__bc, .aw-art__bc, .aw-bc, nav[aria-label="Breadcrumb"], nav[aria-label="breadcrumb"]')) return 'breadcrumb';
    if (c('.aw-ok')) return 'form_thank_you';
    if (c('.aw-hx, .aw-hero')) return c('.aw-hero__popular') ? 'hero_popular_searches' : c('.aw-hx__show') ? 'hero_products' : 'hero';
    if (c('.pagination, .pagination-wrapper, .pagination__list')) return 'pagination';
    if (c('.aw-ci')) return 'concern_icons';
    if (c('.aw-ch__chips, .aw-cc__ql, .aw-cc__qlgrid, .aw-cc__links')) return 'quick_links';
    if (c('[class*="toc"]')) return 'article_toc';
    if (c('.aw-art__prods')) return 'article_products';
    if (c('.aw-cc__blog, .aw-guides, .aw-art-card, .article-card, .blog-articles, .aw-art__links, .aw-ax')) return pt === 'article' ? 'related_articles' : 'blog_cards';
    if (c('.aw-art__ws, .aw-art__help, .aw-ws')) return 'wholesale_cta';
    if (c('.aw-cta')) return 'cta_banner';
    if (c(TILE)) return 'product_card';
    if (c('.aw-art__content, .article-template__content')) return 'article_body';
    if (c('.aw-cc__faq, .aw-faq, .aw-art__faq, .aw-pfaq, [class*="faq"]')) return 'faq';
    if (c('product-info, .product__info-wrapper')) return c('.product__description, .rte') ? 'product_description' : 'product_page';
    if (c('.rte, .page__content, .aw-ch__desc, .aw-cc__body')) return pt === 'product' ? 'product_description' : pt === 'collection' ? 'collection_text' : pt === 'article' ? 'article_body' : 'page_body';
    var sec = a.closest('.shopify-section');
    if (sec && c('main, #MainContent')) return 'section:' + (sec.id.split('__').pop() || sec.id).replace(/^shopify-section-/, '').slice(0, 40);
    return 'other';
  }
  function txt(a) { return clean(a.getAttribute('aria-label') || a.textContent, 80); }
  function handleLink(a, tile) {
    var href = a.getAttribute('href') || '';
    var loc = linkLoc(a), text = txt(a);
    var ct = /wa\.me|api\.whatsapp\.com|whatsapp:\/\//i.test(href) ? 'whatsapp' : /^tel:/i.test(href) ? 'phone' : /^mailto:/i.test(href) ? 'email' : '';
    if (ct) { push(ct + '_click', null, { click_location: loc, link_text: text, link_url: ct === 'whatsapp' ? href.split('?')[0] : href }); return; }
    if (a.tagName === 'SUMMARY') {
      if (loc === 'header_menu' || loc === 'mobile_menu' || loc === 'mega_menu') { push('menu_click', null, { menu_location: loc, link_text: text, link_url: '(open submenu)' }); return; }
      var det = a.closest('details');
      if (det && !det.open && !a.closest('header, .header, cart-drawer, .facets, facet-filters-form, .aw-cpn')) push('faq_open', null, { faq_question: text, click_location: loc });
      return;
    }
    if (/^javascript:/i.test(href) || href === '#aw-finder' || a.hasAttribute('data-aw-q') || a.hasAttribute('data-aw-cpn-remove')) return;
    if (a.matches('.aw-sort__p')) { push('sort_change', null, { sort_by: a.getAttribute('data-sort') || '' }); return; }
    var u = null; try { u = new URL(a.href, location.href); } catch (e) {}
    var internal = !!u && u.hostname.replace(/^www\./, '') === location.hostname.replace(/^www\./, '');
    if (internal && u.pathname !== location.pathname) { try { sessionStorage.setItem('aw_nav', JSON.stringify({ from: location.pathname, to: u.pathname, loc: loc, t: Date.now() })); } catch (e) {} }
    if (MENU[loc]) { push('menu_click', null, { menu_location: loc, link_text: text, link_url: href ? href.replace(location.origin, '') : '' }); return; }
    if (tile) return; /* product cards are reported as select_item */
    var type = !u ? 'other' : !internal ? 'outbound' : (u.pathname === location.pathname && u.hash) ? 'anchor' : 'internal';
    push('link_click', null, { link_location: loc, link_text: text, link_url: !u ? href : internal ? u.pathname + u.search + u.hash : u.href.slice(0, 150), link_type: type, click_type: a.getAttribute('data-aw-track') || undefined });
  }
  var galleryDone = {};
  function cartValue() { if (!snap) return undefined; var v = 0; Object.keys(snap).forEach(function (k) { v += (snap[k].final_line_price != null ? snap[k].final_line_price : snap[k].line_price || 0); }); return money(v); }
  function buttons(el) {
    var b;
    if ((b = el.closest('[name="checkout"]'))) { push('checkout_click', null, { cart_location: b.closest('cart-drawer') ? 'cart_drawer' : b.closest('.aw-cbar') ? 'cart_sticky_bar' : 'cart_page', value: cartValue() }); return; }
    if ((b = el.closest('[data-aw-buy], .shopify-payment-button__button'))) { push('buy_now_click', null, { click_location: linkLoc(b), item_id: handleOf(path) || undefined }); return; }
    if ((b = el.closest('.aw-bulk__p'))) { push('select_pack', null, { option_name: 'Pack offer', option_value: clean(b.textContent, 60), item_id: handleOf(path) || undefined }); return; }
    if ((b = el.closest('.aw-rv2__write'))) { if (b.getAttribute('aria-expanded') !== 'true') push('review_form_open', null, { item_id: handleOf(path) || undefined }); return; }
    if ((b = el.closest('share-button button, .share-button__button, [data-aw-share]'))) { push('share', null, { method: navigator.share ? 'native_share' : 'copy_link', content_type: pt, item_id: handleOf(path) || path }); return; }
    if ((b = el.closest('media-gallery button, media-gallery a, .product__media-wrapper button, .product__media-toggle, modal-opener.product__modal-opener, .thumbnail'))) {
      var act = b.closest('.thumbnail, .thumbnail-list') ? 'thumbnail' : b.closest('.slider-button') ? 'arrow' : 'zoom';
      if (!galleryDone[act]) { galleryDone[act] = 1; push('gallery_interaction', null, { gallery_action: act, item_id: handleOf(path) || undefined }); }
    }
  }

  /* ---------- select_item: product clicked in a list ---------- */
  var lastPick = null; /* {h, list, t, src} – the list behind the next add to cart */
  D.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target : e.target.parentElement;
    if (!el) return;
    var tile = el.closest(TILE);
    if (tile && !(pt === 'product' && tile.closest('product-info'))) {
      var td = tileData(tile);
      if (td) {
        var list = listOf(tile);
        var isAdd = !!el.closest('button, [data-aw-add], .quick-add__submit, input[type="checkbox"]');
        lastPick = { h: td.h, list: list, t: Date.now() };
        setAttr(td.h, list);
        if (!isAdd && el.closest('a[href*="/products/"]')) {
          push('select_item', { currency: CUR, item_list_id: list.id, item_list_name: list.name, items: [gaItem(td.h, td.d, { item_list_id: list.id, item_list_name: list.name, index: indexIn(tile, list) })] });
        }
      }
    }
    /* add-to-cart source (which button) */
    var b = el.closest('button, a, input[type="submit"]');
    if (b) {
      var src = b.getAttribute('data-aw-track') || (b.closest('.aw-satc') ? 'sticky_bar' : b.closest('.aw-fbt') ? 'fbt' : b.closest('.aw-packs, [class*="aw-pack"]') ? 'pack_offer' : b.closest('.quick-add, quick-add-modal') ? 'quick_add' : b.closest('product-info, product-form') ? 'product_page' : b.closest('.aw-up') ? 'cart_upsell' : '');
      /* the sticky bar and pack buttons click the main form button for the shopper: keep the original source */
      var prev = W.awAtcSrc;
      if (src === 'product_page' && prev && prev.s !== 'product_page' && Date.now() - prev.t < 1500) src = '';
      if (src) W.awAtcSrc = { s: src, t: Date.now() };
    }
    /* links, menus, contact clicks, FAQ, product-page and cart buttons */
    var a = el.closest('a[href], summary');
    if (a) handleLink(a, tile);
    buttons(el);
  }, true);

  /* ---------- filters, sorting, pack / size choice ---------- */
  D.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('facet-filters-form, #FacetFiltersForm, #FacetFiltersFormMobile, .facets, .mobile-facets')) {
      if (t.name === 'sort_by') { push('sort_change', null, { sort_by: t.value }); return; }
      if (/^filter\./.test(t.name || '')) {
        var det = t.closest('details'), sum = det && det.querySelector('summary');
        var lab = t.id && D.querySelector('label[for="' + t.id + '"]');
        var fname = clean((sum && sum.textContent) || t.name.replace(/^filter\.(v|p)\./, '').replace(/[._]/g, ' '), 40).replace(/\(\d+\)|\d+ selected/g, '').trim();
        push('filter_apply', null, { filter_name: fname, filter_value: clean((lab && lab.textContent) || t.value, 60).replace(/\(\d+\)\s*$/, '').trim(), filter_action: t.type === 'checkbox' ? (t.checked ? 'add' : 'remove') : 'set' });
      }
      return;
    }
    if (t.closest('variant-selects, variant-radios, .product-form__input')) {
      var fs = t.closest('fieldset'), lg = fs && fs.querySelector('legend');
      push('select_pack', null, { option_name: clean((lg && lg.textContent) || t.name, 40).replace(/:.*$/, ''), option_value: clean(t.value, 60), item_id: handleOf(path) || undefined });
    }
  }, true);

  /* ---------- forms: start, success, errors ---------- */
  var FORMS = 'form#ContactForm, form#ContactFooter, form#aw-review-form, form[data-aw-form], form.newsletter-form';
  function formName(f) {
    return f.getAttribute('data-aw-form') || (f.id === 'aw-review-form' ? 'product_review' : /ContactFooter|newsletter/i.test(f.id + ' ' + f.className) ? 'newsletter' : f.id === 'ContactForm' ? 'contact' : (f.id || 'form'));
  }
  D.addEventListener('focusin', function (e) {
    var f = e.target.closest && e.target.closest(FORMS);
    if (!f || f.__awBegun || !/INPUT|TEXTAREA|SELECT/.test(e.target.tagName) || e.target.type === 'hidden') return;
    f.__awBegun = 1; push('form_begin', null, { form_name: formName(f) });
  });
  D.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest(FORMS); if (!f) return;
    f.__awErr = 0;
    try { sessionStorage.setItem('aw_form_ctx', JSON.stringify({ name: formName(f), page: path, prev: ctxPrev(), t: Date.now() })); } catch (er) {}
  }, true);
  D.addEventListener('invalid', function (e) {
    var f = e.target.closest && e.target.closest(FORMS); if (!f || f.__awErr) return;
    f.__awErr = 1; push('form_error', null, { form_name: formName(f), error_type: 'missing_or_invalid_field', error_field: clean(e.target.name, 40) });
  }, true);
  function formResult() {
    var q = new URLSearchParams(location.search);
    var ctx = null; try { ctx = JSON.parse(sessionStorage.getItem('aw_form_ctx') || 'null'); } catch (e) {}
    if (q.get('contact_posted') === 'true' || q.get('customer_posted') === 'true') {
      var ok = D.querySelector('[data-aw-form-success]');
      var name = ok ? ok.getAttribute('data-aw-form-success') : q.get('customer_posted') === 'true' ? 'newsletter' : D.querySelector('.aw-rv2__ok') ? 'product_review' : (ctx && ctx.name) || 'contact';
      push('form_submit_success', null, { form_name: name, form_page: path, form_source_page: ctx && ctx.page === path ? ctx.prev : undefined });
      try { sessionStorage.removeItem('aw_form_ctx'); q.delete('contact_posted'); q.delete('customer_posted'); history.replaceState(history.state, '', path + (q.toString() ? '?' + q : '') + location.hash); } catch (e) {}
      return;
    }
    var err = D.querySelector('#ContactForm .form__message [role="alert"], #ContactForm-email-error, #ContactFooter-error, .aw-rv2__err');
    if (err) { var f = err.closest('form'); push('form_error', null, { form_name: f ? formName(f) : (ctx && ctx.name) || 'form', error_type: 'server', error_text: clean(err.textContent, 80) }); }
  }

  /* ---------- concern finder, coupon codes, search suggestions (custom events from aw-finder.js / aw-v14.js) ---------- */
  /* concern finder ("Tell us your concern"): watched from the outside, no change to aw-finder.js */
  function watchFinder() {
    var fd = D.getElementById('aw-fd'); if (!fd || !('MutationObserver' in W)) return;
    var out = fd.querySelector('.aw-fd__out'), input = fd.querySelector('.aw-fd__input');
    var how = 'typed', open = fd.classList.contains('is-open'), pending = null;
    fd.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null; if (!t) return;
      if (t.closest('.aw-fd__chip')) { how = 'chip'; pending = clean(t.closest('.aw-fd__chip').getAttribute('data-q') || t.textContent, 100); }
      else if (t.closest('.aw-fd__mic')) how = 'voice';
      else if (t.closest('.aw-fd__lang')) push('concern_finder_language', null, { language: clean(t.closest('.aw-fd__lang').textContent, 20) });
    }, true);
    fd.addEventListener('submit', function () { if (how !== 'voice') how = 'typed'; pending = clean(input && input.value, 100); }, true);
    D.addEventListener('click', function (e) { var t = e.target.closest && e.target.closest('[href="#aw-finder"],[data-aw-q]'); if (t) { how = 'link'; pending = clean(t.getAttribute('data-aw-q') || '', 100); } }, true);
    new MutationObserver(function () {
      var now = fd.classList.contains('is-open');
      if (now && !open) push('concern_finder_open', null, { click_location: 'floating_button' });
      else if (!now && open) push('concern_finder_close', null);
      open = now;
    }).observe(fd, { attributes: true, attributeFilter: ['class'] });
    if (out) new MutationObserver(function () {
      if (out.querySelector('.aw-fd__status') && /…|\.\.\./.test(out.textContent) && !out.querySelector('.aw-fd__grid, .aw-fd__alert, .aw-fd__note')) return; /* still loading */
      var q = pending || clean(input && input.value, 100); if (!q) return;
      var n = out.querySelectorAll('.aw-fd__card').length, head = out.querySelector('.aw-fd__head strong');
      push('concern_search', null, { concern_query: q, concern_method: how, language: /[ऀ-ॿ]/.test(q) || out.lang === 'hi' ? 'hi' : 'en', results_count: n, concern_match: head ? clean(head.textContent, 100) : (n ? 'store_search' : 'no_match'), emergency: out.querySelector('.aw-fd__alert') ? 'yes' : undefined });
      pending = null; how = 'typed';
    }).observe(out, { childList: true });
  }
  D.addEventListener('aw:coupon', function (e) {
    var d = e.detail || {};
    push('coupon_apply', null, { coupon_code: clean(d.code, 40), coupon_status: d.status, cart_location: d.where === 'drawer' ? 'cart_drawer' : 'cart_page', value: d.value });
  });
  var noSug = {};
  D.addEventListener('aw:suggest', function (e) {
    var d = e.detail || {}, q = clean(d.query, 80).toLowerCase();
    if (!d.total && q && !noSug[q]) { noSug[q] = 1; push('search_no_suggestions', null, { search_term: q, search_location: d.where }); }
  });

  /* ---------- search results page ---------- */
  function searchPage() {
    if (pt !== 'searchresults') return;
    var q = new URLSearchParams(location.search).get('q'); if (!q) return;
    var where = 'url'; try { where = sessionStorage.getItem('aw_sloc') || 'url'; sessionStorage.removeItem('aw_sloc'); } catch (e) {}
    var head = D.querySelector('#ProductCountDesktop, #ProductCount, .template-search__header, main h1');
    var t = ((head && head.textContent) || '') + ' ' + D.title, m = t.match(/(\d+)\s+result/i);
    var n = m ? +m[1] : (/no results/i.test(t + ' ' + ((D.querySelector('main') || D.body).textContent || '').slice(0, 4000)) ? 0 : undefined);
    push('search', null, { search_term: clean(q, 100), search_location: where, results_count: n });
  }

  /* ---------- blog: how far the article was read ---------- */
  function articleProgress() {
    if (pt !== 'article') return;
    var body = D.querySelector('.aw-art__content, .article-template__content, .aw-art__main') || D.querySelector('main');
    if (!body) return;
    var marks = [25, 50, 75, 100], sent = {}, title = h1(), tick = false;
    function check() {
      tick = false;
      var r = body.getBoundingClientRect(), h = r.height || 1;
      var pct = Math.max(0, Math.min(100, (innerHeight - r.top) / h * 100));
      marks.forEach(function (mk) { if (pct >= (mk === 100 ? 98 : mk) && !sent[mk]) { sent[mk] = 1; push('article_progress', null, { percent_read: mk, article_title: title }); } });
    }
    W.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    check();
  }

  /* ---------- product page: view_item ---------- */
  function viewItem() {
    if (pt !== 'product') return;
    var p = meta.product; var h = handleOf(path);
    if (!p || !h) return;
    var vid = +(new URLSearchParams(location.search).get('variant') || 0);
    var vs = p.variants || [];
    var v = vs.filter(function (x) { return x.id === vid; })[0] || vs[0] || {};
    var name = h1() || (v.name || '').split(' - ')[0];
    var d = { pid: p.id, name: name, brand: p.vendor, cat: p.type, price: money(v.price) };
    remember(h, d);
    var a = getAttr(h);
    var extra = { item_variant: vs.length > 1 ? (v.public_title || '') : undefined };
    if (a) { extra.item_list_id = a.id; extra.item_list_name = a.name; }
    push('view_item', { currency: CUR, value: money(v.price), items: [gaItem(h, d, extra)] });
    if (D.querySelector('product-info [name="add"][disabled], product-info .product-form__submit[disabled]')) push('out_of_stock_view', null, { item_id: h, item_name: name, item_variant: extra.item_variant });
  }

  /* ---------- cart: add / remove / view, from Shopify's own cart responses ---------- */
  var snap = null; /* variant_id -> line */
  function lineItem(li, qty) {
    var h = li.handle || handleOf(li.url);
    var d = { pid: li.product_id, name: li.product_title || li.title, brand: li.vendor, cat: li.product_type, price: money(li.final_price != null ? li.final_price : li.price) };
    remember(h, d);
    var extra = { item_variant: li.variant_title || undefined, quantity: qty != null ? qty : li.quantity };
    var a = getAttr(h); if (a) { extra.item_list_id = a.id; extra.item_list_name = a.name; }
    return gaItem(h, d, extra);
  }
  function setSnap(cart) {
    if (!cart || !cart.items) return;
    snap = {}; cart.items.forEach(function (li) { snap[li.variant_id || li.id] = Object.assign({}, li); });
  }
  function ecomFor(items) {
    var value = items.reduce(function (s, it) { return s + (it.price || 0) * (it.quantity || 1); }, 0);
    return { currency: CUR, value: Math.round(value * 100) / 100, items: items };
  }
  function atcSource() { var s = W.awAtcSrc; return s && Date.now() - s.t < 15000 ? s.s : ''; }
  function parseBody(body) {
    var out = {};
    try {
      if (!body) return out;
      if (typeof FormData !== 'undefined' && body instanceof FormData) { var id = body.get('id'); if (id) out[id] = +(body.get('quantity') || 1); return out; }
      var s = typeof body === 'string' ? body : (body instanceof URLSearchParams ? body.toString() : '');
      if (!s) return out;
      if (s.charAt(0) === '{') { var j = JSON.parse(s); (j.items || (j.id ? [j] : [])).forEach(function (i) { out[i.id] = (out[i.id] || 0) + +(i.quantity || 1); }); return out; }
      var u = new URLSearchParams(s); if (u.get('id')) out[u.get('id')] = +(u.get('quantity') || 1);
    } catch (e) {}
    return out;
  }
  function onAdd(body, res) {
    var lines = res.items || (res.variant_id || res.id ? [res] : []);
    if (!lines.length) return;
    var req = parseBody(body);
    var items = lines.map(function (li) {
      var vid = li.variant_id || li.id;
      var q = req[vid] != null ? req[vid] : (Object.keys(req).length ? 0 : li.quantity || 1);
      if (snap) { var s = snap[vid]; if (s) s.quantity += q; else snap[vid] = Object.assign({}, li); }
      var it = lineItem(li, q);
      if (lastPick && lastPick.h === it.item_id && Date.now() - lastPick.t < 15000) { it.item_list_id = lastPick.list.id; it.item_list_name = lastPick.list.name; }
      return it;
    }).filter(function (it) { return it.quantity > 0; });
    if (items.length) push('add_to_cart', ecomFor(items), { atc_source: atcSource() || (pt === 'product' ? 'product_page' : 'other') });
  }
  function onChange(res) {
    if (!res || !res.items) return;
    if (!snap) { setSnap(res); return; }
    var now = {}; res.items.forEach(function (li) { now[li.variant_id || li.id] = li; });
    var adds = [], rems = [];
    Object.keys(snap).forEach(function (vid) {
      var before = snap[vid].quantity, after = now[vid] ? now[vid].quantity : 0;
      if (after < before) rems.push(lineItem(snap[vid], before - after));
    });
    Object.keys(now).forEach(function (vid) {
      var before = snap[vid] ? snap[vid].quantity : 0, after = now[vid].quantity;
      if (after > before) adds.push(lineItem(now[vid], after - before));
    });
    setSnap(res);
    /* one response that both removes and adds = the theme swapped singles for a pack (or a variant change) */
    var swap = rems.length && adds.length;
    if (rems.length) push('remove_from_cart', ecomFor(rems), swap ? { cart_change: 'pack_swap' } : null);
    if (adds.length) push('add_to_cart', ecomFor(adds), { atc_source: swap ? 'pack_swap' : 'cart_quantity' });
  }
  function viewCart(cart, where) {
    if (!cart || !cart.items || !cart.items.length) return;
    push('view_cart', ecomFor(cart.items.map(function (li) { return lineItem(li); })), { cart_location: where });
  }
  var lastTotal = null;
  function checkFree(cart) {
    (cart && cart.total_price != null ? Promise.resolve(cart) : getCart()).then(function (c) {
      if (lastTotal != null && lastTotal < 49900 && c.total_price >= 49900) push('free_shipping_reached', null, { value: money(c.total_price) });
      lastTotal = c.total_price;
    }).catch(function () {});
  }
  function getCart() { return fetchOrig((W.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  /* fetch hook: watches Shopify cart API calls made by any button on the site */
  var fetchOrig = W.fetch;
  if (fetchOrig) {
    W.fetch = function (input, init) {
      var p = fetchOrig.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var m = url.match(/\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/);
        if (m) {
          var body = init && init.body;
          p.then(function (r) {
            if (!r || !r.ok) return;
            r.clone().json().then(function (j) {
              if (m[1] === 'add') onAdd(body, j); else onChange(j);
              checkFree(m[1] === 'add' ? null : j);
            }).catch(function () {});
          }).catch(function () {});
        } else if (/\/recommendations\/products(\.json)?|\/products\/[^/]+\.js(?:[?#]|$)|\/search\/suggest(\.json)?/.test(url)) {
          p.then(function (r) {
            if (!r || !r.ok || !/json|javascript/.test(r.headers.get('content-type') || '')) return;
            r.clone().json().then(function (j) {
              var ps = j.products || (j.resources && j.resources.results && j.resources.results.products) || (j.handle ? [j] : []);
              ps.forEach(function (x) { if (x.handle) remember(x.handle, { pid: x.id, name: x.title, brand: x.vendor, cat: x.type, price: x.price != null ? (String(x.price).indexOf('.') > -1 ? +x.price : money(x.price)) : undefined }); });
            }).catch(function () {});
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  /* ---------- start (after the page has loaded, in idle time) ---------- */
  function start() {
    idle(function () {
      viewItem();
      startImpressions();
      var bubble = D.querySelector('.cart-count-bubble');
      if (pt === 'cart') getCart().then(function (c) { setSnap(c); lastTotal = c.total_price; viewCart(c, 'cart_page'); }).catch(function () {});
      else if (bubble) getCart().then(function (c) { setSnap(c); lastTotal = c.total_price; }).catch(function () {});
      formResult();
      searchPage();
      articleProgress();
      watchFinder();
      if (pt === '404' || /^404\b|not found/i.test(D.title)) push('page_not_found', null, { missing_path: (path + location.search).slice(0, 150), previous_page: navCtx.prev });
      setTimeout(function () { try { var n = JSON.parse(sessionStorage.getItem('aw_nav') || 'null'); if (n && n.to === location.pathname) sessionStorage.removeItem('aw_nav'); } catch (e) {} }, 4000);
      var drawer = D.querySelector('cart-drawer');
      if (drawer && 'MutationObserver' in W) {
        var open = drawer.classList.contains('active');
        new MutationObserver(function () {
          var now = drawer.classList.contains('active');
          if (now && !open) setTimeout(function () { getCart().then(function (c) { if (!snap) setSnap(c); viewCart(c, 'cart_drawer'); }).catch(function () {}); }, 400);
          open = now;
        }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
      setTimeout(saveCache, 3000);
    });
  }
  if (D.readyState === 'complete') start(); else W.addEventListener('load', start);
})();
